import React from "react";
import "./DocVerificationHome.scss";
import DocVerifcationForm from "../DocVerificationForm/DocVerificationForm";
import GlobalStore from "../../store/globalStore";
import cleverTapEvents from "../../../config/cleverTapEvents";
import { ClevertapService } from "../../Services/clevertapService";
import useQuery from "../../../customHooks/useQuery";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { DropOffLogAPI } from "../../Services/dashboard/docVerificationAPIServices";
import DocVerifcationFormDynamic from "../DocVerificationForm/DocVerifcationFormDynamic";
import DocVerifcationFormJoint from "../DocVerificationForm/DocVerificationFormJoint";

export interface DocVerificationHomeProps { }

const DocVerificationHome: React.FC<DocVerificationHomeProps> = (props) => {
  // Fetch query params for clervertap
  const quryParams = useQuery();
  const UTM_SOURCE = quryParams.get("utm_source")
    ? quryParams.get("utm_source")
    : "";
  const UTM_MEDIUM = quryParams.get("utm_medium")
    ? quryParams.get("utm_medium")
    : "";
  const UTM_CAMPAIGN = quryParams.get("utm_campaign")
    ? quryParams.get("utm_campaign")
    : "";

  const dropOffObj = () => {
    let userId = 0;
    //  console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    const stageInfoObj = {
      applicationid: GlobalStore?.applicationID,
      accountCagtegory: GlobalStore?.stageStatus?.accountcategory
        ? GlobalStore?.stageStatus?.accountcategory
        : GlobalStore?.accountcategory,
      stageOrderId: 17,
      userId: userId?.toString(),
      rmAssisted: GlobalStore?.stageStatus?.rmassisted,
    };
    DropOffLogAPI(() => { }, stageInfoObj);
  };
  React.useEffect(() => {
    dropOffObj();
    window.sessionStorage.setItem("stageInfoId", "6");
  }, []);

  // Clervertap event: Profiler/Investment screen is loaded
  React.useEffect(() => {
    const data = {
      EventName:
        cleverTapEvents.registration.documentVerificationPage.PAGE_LOAD,
      InitiationPlatform: "",
      UTM_SOURCE,
      UTM_MEDIUM,
      UTM_CAMPAIGN,
      KRA: GlobalStore.isKRA,
      DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
      ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: GlobalStore.applicationID,
    };

    ClevertapService.pushEvent(data);
  }, []);

  return (
    <div className="docHome">
      <h1 className="docHeading">Verify Personal Documents</h1>
      <div className="docSubHeading">
        {GlobalStore.entitySubType == "Minor" ?
          <p>
            Please share documents of account holder/ guardian below
          </p>
          :
          <p>
            Share PDF/PNG/JPG files of your documents for account opening and
            verification
          </p>
        }
      </div>

      {(GlobalStore.entityType == "NONINDIVIDUAL" || GlobalStore.isOTCFlow || GlobalStore.isNriOtc) ?
        <DocVerifcationFormDynamic
          UTM_SOURCE={`${UTM_SOURCE}`}
          UTM_MEDIUM={`${UTM_MEDIUM}`}
          UTM_CAMPAIGN={`${UTM_CAMPAIGN}`}
        /> :
        GlobalStore.entitySubType == "Joint" ?
          <DocVerifcationFormJoint
            UTM_SOURCE={`${UTM_SOURCE}`}
            UTM_MEDIUM={`${UTM_MEDIUM}`}
            UTM_CAMPAIGN={`${UTM_CAMPAIGN}`}
          />
          :
          <DocVerifcationForm
            UTM_SOURCE={`${UTM_SOURCE}`}
            UTM_MEDIUM={`${UTM_MEDIUM}`}
            UTM_CAMPAIGN={`${UTM_CAMPAIGN}`}
          />
      }
    </div>
    // <div className='docHome'>
    //     <div className='docHeading'>
    //         <label>Document Verification</label>
    //     </div>
    //     <div className="docSubHeading">
    //         <label>Share PDF/PNG/JPG files of your documents for account opening and verification</label>
    //     </div>
    //     <DocVerifcationForm />
    // </div>
  );
};

export default DocVerificationHome;
